<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="新增年月">
                <el-date-picker
                        class="date"
                        v-model="dataForm.ymd"
                        type="month"
                        size="small"
                        :clearable="true"
                        format="yyyy-MM"
                        value-format="yyyy-MM"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="新增金额" prop="addAmount">
                <el-input v-model="dataForm.addAmount" oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入新增金额"></el-input>
            </el-form-item>
            <el-form-item label="发放模式" prop="selectDeviceType">
                <el-select @change="selectChanged" v-model="dataForm.selectDeviceType" placeholder="发放模式">
                    <el-option
                            v-for="item in allStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <template v-if="dataForm.showDevice==true">
            <el-form-item   label="设备数" prop="deviceNum">
                <el-input v-model="dataForm.deviceNum" oninput ="value=value.replace(/[^\d]/g,'')" placeholder="设备数"></el-input>
            </el-form-item>
            </template>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'
    export default {
        data() {
            return {
                visible: false,
                dataForm: {
                    id: '',
                    ymd: '',
                    addAmount: '',
                    deviceNum: -1,
                    status: '',
                    selectDeviceType:0,
                    showDevice: true,
                },
                allStatus: [{
                    value: 0,
                    label: '指定设备数'
                },{
                    value: 1,
                    label: '全部发放'
                }],
            }
        },
        computed: {
            dataRule() {
                return {
                    addAmount: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    deviceNum: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init() {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
            },
            selectChanged(value){
              console.log(value);
              debugger;
              if(value==1) {
                  this.dataForm.showDevice=false;
                  this.dataForm.deviceNum=-1;
              }else{
                  this.dataForm.showDevice=true;
                  this.dataForm.deviceNum=0;

              }
            },
            // 获取信息
            getInfo() {
                this.$http.get(`/dms/deviceStorageApp/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }
                    this.dataForm.selectDeviceType=0
                    selectChanged(this.dataForm.deviceNum);
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http[!this.dataForm.id ? 'post' : 'put']('/dms/deviceStorageApp/', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>
